import { constants } from '../../constants';
import { inspect } from 'util';
import { PageModelType, resType } from './index.types';
const { NEXT_PUBLIC_DYNAMIC_ROUTING_URL } = process.env;
const { ROUTING_CONFIG, APPLICATION_NAME, EXPERIENCE_SEGMENT } = constants;

export function getItemFromPageModel(pageModel: PageModelType, itemPath: string) {
  const parts = itemPath.split('/');
  let obj = pageModel;

  for (let i = 0; i < parts.length && obj; i++) {
    obj = (obj[':items'] || {})[parts[i]];
  }

  return obj || {};
}

export async function getPageModel(path: string, locale: string, sessionID: string, requestId: string) {
  const { log, pLog } = global.loggerInstance('ModelCall');
  // const locale = preData?.contexts?.global?.localeKey?.toLowerCase()?.replace('_', '-');
  locale = locale?.replace('_', '-');
  const pagePath = path.split('?')[0];

  const getCMSTemplateReqBody = {
    requestType: ROUTING_CONFIG,
    seoUrl: pagePath,
    localeKey: locale,
    experienceSegment: EXPERIENCE_SEGMENT,
    applicationName: APPLICATION_NAME,
    sessionToken: sessionID,
  };

  const config = {
    headers: {
      'Content-Type': 'application/json',
      requestID: requestId,
    },
  };

  log.debug(`getCMSTemplateReqBody1: ${JSON.stringify(getCMSTemplateReqBody)}`);
  log.debug(`Model Call config: ${inspect(config)}`);

  let pageModel = {};
  const apiStartTime = new Date().getTime();
  try {
    log.debug(`NEXT_PUBLIC_DYNAMIC_ROUTING_URL: ${NEXT_PUBLIC_DYNAMIC_ROUTING_URL}`);
    log.debug(`getCMSTemplateReqBody: ${JSON.stringify(getCMSTemplateReqBody)}`);
    const responseData = await fetch(`${NEXT_PUBLIC_DYNAMIC_ROUTING_URL}`, {
      method: 'POST',
      headers: {
        ...config.headers,
      },
      body: JSON.stringify(getCMSTemplateReqBody), // Convert body to JSON
    });
    const response = await responseData.json();
    log.debug(`AEM model API call success with status code: ${response.status}`);
    if (response) {
      log.debug(`AEM model recieved: ${inspect(response)}`);
      pageModel = response.data;
    } else {
      log.debug(`AEM model failure: ${response}`);
      pageModel = {};
    }
  } catch (err) {
    log.error(`API call failed: ${err}`);
    //returing page model and logging error
    return pageModel;
  }
  pLog.log('API call performance timing', apiStartTime, new Date().getTime());
  return pageModel;
}

//converts ":items" format to "cqItems" format.
export function transformToCQ(propKey: string) {
  const tempKey = propKey.substring(1);

  return 'cq' + tempKey.substring(0, 1).toUpperCase() + tempKey.substring(1);
}

export function getDataLayerScript(dataLayer?: { data: Record<string, string>; mvpOffersData: string }) {
  return `var dataLayer = ${dataLayer ? JSON.stringify(dataLayer.data[0]) : '{}'};`;
}

export const findEmailByMarshaCode = (marshaCode: string, pocEmailList: Record<string, string> | null) => {
  if (!Array.isArray(pocEmailList)) {
    return null;
  }
  const pocEmail = pocEmailList?.find((item: resType['res']) => item?.key === marshaCode);
  return pocEmail ? pocEmail?.value : null;
};
